import { MEDIA_UPLOAD_PROTOCOL_ID, MediaAssetsRegistry, MediaTransformationsRegistry } from '@common/media/shared';
import { DevConsoleProtocolLogger, injectableProtocolFactory } from '@core/frontend-shared';
import { MediaAssetsFrontendRegistry } from './media-assets-frontend.registry';
import * as i0 from "@angular/core";
import * as i1 from "@common/media/shared";
export let MediaFrontendSharedModule = /*#__PURE__*/(() => {
  class MediaFrontendSharedModule {
    constructor(reg) {}
    static {
      this.ɵfac = function MediaFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MediaFrontendSharedModule)(i0.ɵɵinject(i1.MediaAssetsRegistry));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MediaFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [MediaAssetsFrontendRegistry, {
          provide: MediaAssetsRegistry,
          useExisting: MediaAssetsFrontendRegistry
        }, {
          provide: MediaTransformationsRegistry,
          useFactory: () => new MediaTransformationsRegistry()
        },
        // NOTE: in use! Just hidden. MediaAssetProvidersBaseService passes the instance to individual media provider plugins.
        injectableProtocolFactory(MEDIA_UPLOAD_PROTOCOL_ID, "MediaUpload", [DevConsoleProtocolLogger], (protocol, config) => {
          protocol.setGroupNameProcessor(name => name.toString().substring(0, 12));
          return protocol;
        })]
      });
    }
  }
  return MediaFrontendSharedModule;
})();